import { useColorScheme } from '@/contexts/ColorSchemeContextProvider';
import { CompleteTheme } from '@nivo/core';

export default function useChartTheme(): Partial<CompleteTheme> {
  const [colorScheme] = useColorScheme();
  const isDark = colorScheme === 'dark';

  return {
    axis: {
      domain: {
        line: {},
      },
      legend: {
        text: {
          fontSize: 12,
          fill: isDark ? '#eee' : '#333',
        },
      },
      ticks: {
        text: {
          fontSize: 11,
          fill: isDark ? '#eee' : '#333',
        },
        line: {},
      },
    },
    legends: {
      text: {
        fontSize: 12,
        fill: isDark ? '#eee' : '#333',
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any,
    labels: {
      text: {
        fill: isDark ? '#eee' : '#333',
      },
    },
    tooltip: {
      container: {
        backgroundColor: isDark ? '#444' : '#fff',
      },
      basic: {},
      chip: {},
      table: {},
      tableCell: {},
      tableCellValue: {},
    },
  };
}
